module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-toc",
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('div', {
    staticClass: "toc-heading"
  }, [_c('h3', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/alsobypatriciadixon"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Also by Patricia Dixon")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-foreword has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Foreword")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/nomoreyesterdays"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("No More Yesterdays")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/achangeofplan",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("A Change of Plan")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/fromthemouthsofbabes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("From the Mouths of Babes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/achristmastale",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("A Christmas Tale")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-acknowledgments has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Acknowledgements")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/anotefromthepublisher",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("A note from the publisher")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/lovewomenscontemporaryfiction",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Love Women’s Contemporary Fiction?")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0